import { useApiClient } from '../composables/useApiClient.ts';
import type { TwoFactorMethod } from '../constants/two-factor.ts';

// The owner's own second factor. The public login steps go through the user store.
export default {
    getSelf() {
        return useApiClient().get('/two-factor');
    },
    setup(data: { method: TwoFactorMethod, password: string }) {
        return useApiClient().post('/two-factor/setup', data);
    },
    sendCode() {
        return useApiClient().post('/two-factor/code');
    },
    confirm(data: { code: string }) {
        return useApiClient().post('/two-factor/confirm', data);
    },
    startChange(data: { password: string, code: string, recovery: boolean, method: TwoFactorMethod }) {
        return useApiClient().post('/two-factor/change', data);
    },
    disable(data: { password: string, code: string, recovery: boolean }) {
        return useApiClient().post('/two-factor/disable', data);
    },
    regenerateRecoveryCodes(data: { password: string, code: string, recovery: boolean }) {
        return useApiClient().post('/two-factor/recovery-codes', data);
    },
};
